<h1 mat-dialog-title>{{data.USUARIO}}</h1>
<div mat-dialog-content>
  <p>Seleccione nuevo origen</p>
  <mat-form-field>
    <mat-label>Piloto de origen...</mat-label>
    <mat-select [(ngModel)]="data.ID_ORIGEN">
      <mat-option *ngFor="let origen of origenes" [value]="origen.ID_ORIGEN">
        {{origen.DESCRIPCION}}
      </mat-option>
    </mat-select>
  </mat-form-field>
</div>
<div mat-dialog-actions>
  <button mat-button color="primary" [mat-dialog-close]="data">Guardar</button>
</div>
